import { apiFetch } from "./http";

// Fatura adresi — müşterinin kendi org'una bağlı. Bireysel/kurumsal varyant.
export type BillingAddress = {
  id: number;
  org_id: number;
  title: string;
  address_type: "bireysel" | "kurumsal";
  first_name?: string;
  last_name?: string;
  tc_kimlik_no?: string;
  company_name?: string;
  tax_office?: string;
  tax_no?: string;
  country: string;
  state?: string;
  city?: string;
  postal_code?: string;
  email?: string;
  phone?: string;
  full_address?: string;
  created_at: string;
};

export type BillingAddressInput = {
  title: string;
  address_type: "bireysel" | "kurumsal";
  first_name?: string;
  last_name?: string;
  tc_kimlik_no?: string;
  company_name?: string;
  tax_office?: string;
  tax_no?: string;
  country?: string;
  state?: string;
  city?: string;
  postal_code?: string;
  email?: string;
  phone?: string;
  full_address?: string;
};

async function errText(res: Response): Promise<string> {
  let msg = `HTTP ${res.status}`;
  try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
  return msg;
}

export async function listBillingAddresses(): Promise<BillingAddress[]> {
  const res = await apiFetch("/api/v1/billing-addresses");
  if (!res.ok) throw new Error(`listBillingAddresses: HTTP ${res.status}`);
  const data = (await res.json()) as { billing_addresses: BillingAddress[] | null };
  return data.billing_addresses ?? [];
}

export async function createBillingAddress(input: BillingAddressInput): Promise<BillingAddress> {
  const res = await apiFetch("/api/v1/billing-addresses", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(await errText(res));
  return res.json();
}

export async function deleteBillingAddress(id: number): Promise<void> {
  const res = await apiFetch(`/api/v1/billing-addresses/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 404) throw new Error(`deleteBillingAddress: HTTP ${res.status}`);
}
